import { useEffect } from 'react';

import { useIsAuthenticated } from '@azure/msal-react';

import { useGetAssignedMandantHook } from '../use-get-asigned-mandant/use-get-asigned-mandant.hook';

export const useSetMandant = (): void => {
  const isAuthenticated = useIsAuthenticated();
  const onFetchAndSetMandant = useGetAssignedMandantHook();

  useEffect(() => {
    onFetchAndSetMandant().then();
  }, [isAuthenticated]);
};
